import type { MonetaryValue } from '@shared/lib/money/money'
import { formatMoney } from '@shared/lib/format/currency'
import { impactCopy, impactDetail, impactLead } from './sale-impact-copy.css'

type SaleImpactCopyProps = {
  active: MonetaryValue
  original: MonetaryValue
  affected: MonetaryValue
  align?: 'start' | 'end'
  prominence?: 'compact' | 'prominent'
}

export function SaleImpactCopy({
  active,
  original,
  affected,
  align = 'start',
  prominence = 'compact',
}: SaleImpactCopyProps) {
  return (
    <span className={impactCopy({ align })}>
      <span className={impactLead({ prominence })}>
        {formatMoney(active.amount, active.currency)} de{' '}
        {formatMoney(original.amount, original.currency)} continuam válidos
      </span>
      <span className={impactDetail({ prominence })}>
        {formatMoney(affected.amount, affected.currency)} foram reembolsados ou contestados.
      </span>
    </span>
  )
}
